module.exports = __webpack_public_path__ + "static/img/yiNew2.542512f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/yiNew2.jpg
// module id = 6GfI
// module chunks = 0